import styled from 'styled-components';

export const StyledDayPicker = styled.div.attrs(props => ({
    className: props.className
}))`
  background: #E6E3FC;
  border-radius: 12px;
  
  .content {
    margin: 25px;
    display: grid;
    grid-template-columns: repeat(7, 30px);
    grid-gap: 5px;
    
    .day {
      user-select: none;
      font-weight: 600;
      color: #373647B2;
      cursor: pointer;
      width: 30px;
      height: 30px;
      background: #F3F1FF;
      border-radius: 8px;
      display: flex;
      justify-content: center;
      align-items: center;
      
      &.active {
        font-weight: 700;
        color: #fff;
        background: #6E74FF;
      }
    }
  }
  
`